import { __assign } from 'tslib';
import React__default from 'react';
import { useNavigation } from '../../../context/NavigationConfigContext.esm.js';
import '../../../context/NavigationCtaContext.esm.js';
import { SignedInNavigation } from './SignedInNavigation.esm.js';

var NucleobaseShellSignedInNavigation = function () {
    var navigation = useNavigation();
    if (!navigation || !(navigation === null || navigation === void 0 ? void 0 : navigation.signedInProps) || Object.keys(navigation).length === 0)
        return null;
    return React__default.createElement(SignedInNavigation, __assign({}, navigation.signedInProps));
};

export { NucleobaseShellSignedInNavigation };
//# sourceMappingURL=NucleobaseShellSignedInNavigation.esm.js.map
